export const getPrintableInvoiceHtml = (htmlFiles: string[]): string => {
  if (htmlFiles.length < 2) {
    return htmlFiles[0] ?? ''
  }

  const parser = new DOMParser()
  const [firstPage, ...otherPages] = htmlFiles.map((htmlFile) => parser.parseFromString(htmlFile, 'text/html'))

  firstPage.body.innerHTML = [firstPage, ...otherPages]
    .map((page) => `<div style="break-after: page;">${page.body.innerHTML}</div>`)
    .join('')

  return `<!DOCTYPE html>${firstPage.documentElement.outerHTML}`
}
